import React, { useEffect, useState } from 'react';
//import WeeklySales from './WeeklySales';
import { Row, Col, Spinner, Card, Button, Alert } from 'react-bootstrap';
//import team1 from 'assets/img/team/3.jpg';
import AbsenceThisYear from './AbsenceThisYear';
import SharedFiles from './SharedFiles';
import ActiveUsers from './ActiveUsers';
import CalendarManagement from 'components/app/management-events/CalendarManagement';
import ToDoList from './ToDoList';
import HolidayService from '../../app/holidays/HolidayService';
import EventService from '../../app/management-events/EventService';
import DirectoryService from 'components/app/directory/DirectoryService';
import DocumentService from 'components/app/documents/DocumentService';
import defaultAvatar from 'assets/img/team/avatar.png';
import AnnoucementWidget from 'components/app/annoucements/AnnoucementWidget';
import InternalVacanciesWidget from 'components/app/rolepositions/InternalVacanciesWidget';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import 'shepherd.js/dist/css/shepherd.css'; // Import default styles
import TourService from 'components/app/common/TourService';
import '@fortawesome/fontawesome-free/css/all.min.css';
import GoalService from 'components/app/performance-management/GoalService';
import DemoService from 'components/app/common/functions/DemoService';
import ProgressBarWidget from 'components/app/common/functions/ProgressBarWidget';
import FeedbackWidget from 'components/app/performance-management/FeedbackWidget';
import Directory from '../analytics/directory/Directory';
import OnboardingWidget from './OnboardingWidget';

const HRDashboard = () => {
  const [activeUsers, setActiveUsers] = useState([]);
  const [outOfOfficeToday, setOutOfOfficeToday] = useState([]);
  const [sharedDocs, setSharedDocs] = useState([]);
  const [managementEvents, setManagementEvents] = useState([]);
  const [initialEvents, setInitialEvents] = useState([]);
  const [profile, setProfile] = useState();
  const { instance, accounts } = useMsal();
  const [showCalendar, setShowCalendar] = useState(false);
  const [loadingAbsences, setLoadingAbsences] = useState(true);
  const [absencesThisYear, setAbsencesThisYear] = useState([]);
  const [error, setError] = useState('');
  const [progressBarChart, setProgressBarChart] = useState();
  const [showProgressBarChart, setShowProgressBarChart] = useState(false);

  const navigate = useNavigate();
  const fetchAbsences = async () => {
    try {
      const { identifier } = DirectoryService.retrieveLoggedProfile();
      const profile = await DirectoryService.retrieveProfile(identifier); // To get the last one
      setProfile(profile);

      const data = await HolidayService.retrieveAbsencesThisYear();
      const response = await HolidayService.getValuesForAbsencesChart(
        profile,
        data
      );
      setAbsencesThisYear(response);
      setLoadingAbsences(false);
    } catch (error) {
      console.error('Error fetching absences:', error); // Handle errors
      setLoadingAbsences(true); // Ensure loading state is updated even on failure
    }
  };

  useEffect(() => {
    fetchAbsences();

    DirectoryService.retrieveUsersByAccount()
      .then(users => {
        const activeUsers = users.map(u => ({
          id: u.identifier,
          name: u.firstName + ' ' + u.lastName,
          avatar: {
            status: u.online === true ? 'online' : 'offline',
            src: u.avatar || defaultAvatar,
            size: '2xl'
          }
        }));
        setActiveUsers(activeUsers);
      })
      .catch(error => setError(error.message));

    DirectoryService.retrieveOutOfOfficeToday()
      .then(users => {
        const outOfOfficeToday = users.map(u => ({
          id: u.identifier,
          name: u.firstName + ' ' + u.lastName,
          avatar: {
            status: u.status || 'offline',
            src: u.avatar || defaultAvatar,
            size: '2xl'
          }
        }));
        setOutOfOfficeToday(outOfOfficeToday);
      })
      .catch(error => setError(error.message));
    const demoGoals = DemoService.retrieveDemoGoals().map(goal => ({
      deadline: goal.deadline,
      description: goal.description,
      identifier: goal.identifier,
      name: goal.name,
      profileIdentifier: goal.profileIdentifier,
      progress: goal.progress,
      targetValue: goal.targetValue
    }));
    GoalService.retrieveAllGoalByAccount()
      .then(data => {
        console.log("retrieveAllGoalsByAccount", data);
        if (localStorage.getItem('bstDemoMode') === 'true' || !data.length) {
          data.push(...demoGoals.slice(1, 4));
        }
        console.log("Data.length: ", data.length);
        
        const progressBarData = data.map(goal => ({
          name: goal.name,
          progress: goal.progress
        }));
        
        setProgressBarChart(progressBarData);
        setShowProgressBarChart(data.length > 0);
      })
      .catch(error => setError({ error: error.message }));

    DocumentService.retrieveDocumentsByProfile().then(docs => {
      const sharedDocs = docs.map(d => ({
        id: d.identifier,
        img: d.img,
        name: d.name,
        time: d.dateCreated,
        user: d.profile.email,
        border: true
      }));
      setSharedDocs(sharedDocs);
    });

    const fetchEvents = async () => {
      const events = await EventService.retrieveManagementEvents();
      // const holidayRequests = await HolidayService.retrieveHolidayRequests();
      let msEvents = await EventService.retrieveMicrosoftEvents(
        instance,
        accounts
      );
      if (msEvents === undefined) {
        msEvents = [];
      }
      // Merge the two arrays using the spread operator
      const mergedEvents = [...events, ...msEvents];
      setInitialEvents(mergedEvents);
      console.log(initialEvents); // DELETE this logic
      setManagementEvents(mergedEvents);
      setShowCalendar(true);
    };
    fetchEvents();

    const showGuide = localStorage.getItem('bstShowGuide');
    if (showGuide === 'true') {
      const tour = TourService.retrieveMainTour();
      tour.start();
    }
  }, []);
  return (
    <>
      {error}
      <Row className="g-3 mb-3">
        <Col md={6} xxl={8}>
          <AnnoucementWidget />
        </Col>
        <Col md={6} xxl={4}>
          {!loadingAbsences && !profile?.contract && (
            <>
              <Card lassName="pb-0 text-center fs--1">
                <Card.Header>
                  <h6 className="fs-0 text-capitalize">Holidays</h6>
                </Card.Header>
                <Alert variant="info" key={'info'} className="m-0 p-2">
                  <h6>You haven't set up your holiday entitlement yet.</h6>
                </Alert>
                <Card.Body className="pb-0 text-center">
                  <Button
                    size="m"
                    className="p-2 m-1 fs--1"
                    onClick={() => navigate('/social/directory/my-details')}
                  >
                    Go to your details
                  </Button>
                </Card.Body>
              </Card>
            </>
          )}
          {loadingAbsences ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            profile?.contract && (
              <AbsenceThisYear
                data={absencesThisYear}
                radius={['100%', '87%']}
              />
            )
          )}
        </Col>

      </Row>
      <Row className="g-3">
        <Col xxl={8}>
          {showCalendar && <CalendarManagement data={managementEvents} />}
        </Col>
        <Col xxl={4} id="activeUsers">
          <ActiveUsers
            title={'Active users'}
            className="h-100"
            users={activeUsers}
          />
        </Col>
      </Row>
      <br/>
      <OnboardingWidget />
      <br/>
      <Row className="g-3 mb-3">
        <Col lg={12} xl={12} id="toDoList">
          <ToDoList />
        </Col>
      </Row>  
      {!DirectoryService.isLoggedByHRAdmin() && <FeedbackWidget />}
      <Row className="g-3 mb-3">
        <Col lg={7} xl={8}>
          {showProgressBarChart && <ProgressBarWidget title={false} goals={progressBarChart} height={'10rem'} />}
        </Col>
        <Col lg={5} xl={4} id="shareFiles">
          <InternalVacanciesWidget className="h-lg-100"/>
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col lg={7} xl={8} id="internalVacancies">
          <SharedFiles files={sharedDocs.slice(0, 5)} className="h-lg-100" />
        </Col>
        <Col lg={5} xl={4} id="outOfOfficeToday">
          <ActiveUsers
            className="h-40"
            title={'Out of office today'}
            users={outOfOfficeToday}
          />
        </Col>
      </Row>
    </>
  );
};

export default HRDashboard;
